import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './TaskResponseForm.scss';
import classNames from 'classnames';
import {formatDate} from "../../../shared/services/utils/utils";
import DatePicker from 'react-datepicker';
import 'react-datepicker/src/stylesheets/datepicker.scss';
import moment from 'moment';
import LoadingButton from "../../../shared/ui/LoadingButton";
import {FormGroup, Input} from "reactstrap";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import Checkbox from "../../../shared/forms/Checkbox";

class TaskResponseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: moment(),
      isDateOpen: false,
      isFormOpen: false,
      comment: '',
      substandard: false,
      hasCommentForEdit: true,
      responses: {
        explained: !!this.isChecked('explained'),
        practiced: !!this.isChecked('practiced'),
        demonstrated: !!this.isChecked('demonstrated')
      },
      currentResponse: '',
      isEditing: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(!prevState.isEditing && nextProps.editingResponse && nextProps.task.taskResponses.find(tr => tr.guid === nextProps.editingResponse.guid)) {
      return {
        currentResponse:  nextProps.editingResponse.action,
        selectedDate: moment(nextProps.editingResponse.actionAt),
        substandard: nextProps.editingResponse.substandard,
        isEditing: true
      }
    }
    return {}
  }

  get hasSelectedActions() {
    return !!this.state.currentResponse;
  }

  handleDateChange(date) {
    this.setState({selectedDate: date})
  }


  isChecked(response) {
    let res = this.props.task.taskResponses.find(tr => tr.action === response);
    return res && res.guid !== (this.props.editingResponse && this.props.editingResponse.guid);
  }

  openForm() {
    this.setState({
      isFormOpen: true
    })
  }

  handleCheck(e) {
    let {name, checked} = e.target;

    if(this.isEditingResponse) {
      this.setState({
        responses: Object.keys(this.state.responses)
          .reduce((acc, response) => {
            return {
              ...acc,
              [response]: this.isChecked(response)? true: (response === name)? checked: false
            }
          }, {}),
        currentResponse: this.state.responses[0]
      })
    } else {
      this.setState({
        responses: {
          ...this.state.responses,
          [name]: checked
        },
      })
    }
  }

  closeForm() {
    if(this.props.editingResponse && this.props.editingResponse.task.guid === this.props.task.taskGuid) {
      this.props.cancelEditResponse()
    }
    setTimeout(() => {
      this.setState({
        isFormOpen: false,
        responses: {
          explained: !!this.isChecked('explained'),
          practiced: !!this.isChecked('practiced'),
          demonstrated: !!this.isChecked('demonstrated')
        }
      })
    }, 10)

  }

  setComment(comment) {
    this.setState({
      comment,
      hasCommentForEdit: false
    })
  }

  saveResponses() {
    this.props.onSaveResponse({
      taskGuid: this.props.task.taskGuid,
      actions: [this.state.currentResponse],
      actionAt: this.state.selectedDate.toISOString(),
      comment: this.state.comment,
      substandard: this.state.substandard
    }).then(() => {
      this.setState({
        comment: '',
        hasCommentForEdit: true,
        currentResponse: '',
        substandard: false,
        isEditing: false
      })
    })

  }

  updateCurrentResponse(e) {
    this.setState({
      currentResponse: e.target.value
    })
  }

  updateSubstandard(e) {
    this.setState({
      substandard: e.target.checked
    })
  }

  get canAdd() {
    return true;
    return !(!!this.isChecked('explained') && !!this.isChecked('practiced') && !!this.isChecked('demonstrated'))
      || (this.props.editingResponse && this.props.editingResponse.task.guid === this.props.task.taskGuid);
  }

  get isFormOpened() {
    return this.state.isFormOpen || (this.props.editingResponse && this.props.editingResponse.task.guid === this.props.task.taskGuid);
  }

  get isEditingResponse() {
    return this.props.task.taskResponses.find(tr => tr.guid === (this.props.editingResponse && this.props.editingResponse.guid))
  }

  render() {
    return (
      <div className={classNames("task-response")}>
        {this.isFormOpened && this.canAdd && (
          <div>
            <Checkbox
              label="This task was performed below standards."
              checked={this.state.substandard}
              onChange={(e) => this.updateSubstandard(e)}
            />
            <div className="task-responses-form">
              <DatePicker
                selected={this.state.selectedDate}
                onChange={this.handleDateChange.bind(this)}
                customInput={
                  <div>
                    <button className="button secondary small">
                      <i className="fa fa-edit"/>
                      <span>{formatDate(this.state.selectedDate)} </span>
                    </button>
                  </div>
                }
              />

              {/*<Checkbox*/}
              {/*  disabled={this.isChecked('explained')}*/}
              {/*  name="explained"*/}
              {/*  label="Explained"*/}
              {/*  checked={this.state.responses.explained}*/}
              {/*  onChange={(e) => this.handleCheck(e)}/>*/}
              {/*<Checkbox*/}
              {/*  disabled={this.isChecked('demonstrated')}*/}
              {/*  name="demonstrated"*/}
              {/*  label="Demonstrated"*/}
              {/*  checked={this.state.responses.demonstrated}*/}
              {/*  onChange={(e) => this.handleCheck(e)}/>*/}
              {/*<Checkbox*/}
              {/*  disabled={this.isChecked('practiced')}*/}
              {/*  name="practiced"*/}
              {/*  label="Practiced"*/}
              {/*  checked={this.state.responses.practiced}*/}
              {/*  onChange={(e) => this.handleCheck(e)}/>*/}

              <div className="form-group">
                <select className="form-control" value={this.state.currentResponse}
                        onChange={(e) => this.updateCurrentResponse(e)}>
                  <option value="">Choose response</option>
                  {this.props.availableTaskResponses.map(response => (
                    <option value={response}>{response}</option>
                  ))}
                </select>
              </div>

              <div style={{marginLeft: '20px'}}>
                <LoadingButton
                  primary
                  small
                  icon="fa fa-save"
                  disabled={!this.hasSelectedActions}
                  text="Submit"
                  isLoading={this.props.isLoading}
                  onClick={() => this.saveResponses()}/>
              </div>
              <div style={{marginLeft: '20px'}}>
                <button className="button secondary small" onClick={() => this.closeForm()}>
                  <i className="fa fa-close"/>
                </button>
              </div>
            </div>
            <div className="form blank-form">
              <FormGroup>
                <Input
                  onChange={event => this.setComment(event.target.value)}
                  value={this.state.hasCommentForEdit && this.props.editingResponse? this.props.editingResponse.authorComment: this.state.comment}
                  type="textarea"
                  placeholder="Comment"
                />
              </FormGroup>
            </div>
          </div>
        )}
        {!this.isFormOpened && this.canAdd && (
          <button className="button small primary" onClick={() => this.openForm()}>
            <i className="fa fa-plus" />
            <span>Add response</span>
          </button>
        )}
      </div>
    );
  }
}

TaskResponseForm.propTypes = {
  task: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    availableTaskResponses: departmentSettingsSelectors.availableTaskResponses(state)
  }
};

export default connect(mapStateToProps)(TaskResponseForm);
